import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Col, Container } from "reactstrap";
import {
    doc, 
    setDoc,
    serverTimestamp
} from "firebase/firestore";
import { db } from "../firebase-config";

export const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

    const[isSubmitted, setIsSubmitted] = useState(false);
    const[isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit =  async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const newData = {
      name: form.name ? form.name : "",
      email: form.email ? form.email : "",
      message: form.message ? form.message : "",
    };
    //  save to firestore

    try {
    const newMessage = await setDoc(
      doc(
        db,
        "messages",
        `
        ${Date.now()}
        `
      ),
      {
        ...newData,
        createdAt: serverTimestamp(),
      }
    );
    setIsSubmitted(true);
    setIsSubmitting(false);
    } catch (error) {
        console.log(error);
        setIsSubmitting(false);
    }
  };
  return (
    <div className="section-title-one">

        {isSubmitted && (
        <div className="alert alert-success" role="alert"> 
                    Thanks for reaching out!
        </div>
        )}
    <Container className="bg-light border">
      <div className="my-4">
          <Form onSubmit={handleSubmit}>
          <FormGroup row>
              <Label for="message" sm={2}>
                    Message
                <span className="text-danger">*</span>
              </Label>
              <Col sm={10}>
                <Input
                  id="message"
                  name="message"
                  type="textarea"
                  placeholder="Leave us a suggestion, a feature you wanna add maybe? a bug you caught? want to contribute? or maybe just say hello?"
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  value={form.message}
                  required
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="exampleEmail" sm={2}>
                Email
              </Label>
              <Col sm={10}>
                <Input
                  id="exampleEmail"
                  name="email"
                  placeholder="Your email, so we can contact you back if needed (optional)"
                  type="email"
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  value={form.email}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="name" sm={2}>
                Name 
              </Label>
              <Col sm={10}>
                <Input
                  id="name"
                  name="name"
                  placeholder="(Completely optional)"
                  type="text"
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  value={form.name}
                />
              </Col>
            </FormGroup>
            {/* Submit */}
            <FormGroup row>
              <Col
                sm={{
                  offset: 2,
                  size: 10,
                }}
              >
                <Input type="submit" value=
                
                
                {isSubmitting ? "Sending..." : "Send"}
                className="btn btn-primary" 
                
                disabled = {isSubmitting || isSubmitted}
                />
              </Col>
            </FormGroup>
          </Form>
      </div>
    </Container>
    </div>
  );
};

export default Contact;